<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div class="avatar-container">
      <div class="avatar-wrapper">
        <!-- <img class="user-avatar" :src="avatar">
         <span class="curPon" @click="authCode" style="display:block;margin-right: 10px;font-size: 14px;">业务二维码</span> -->
        <span>{{nickName || '--'}}({{ username || '--'}})</span>
        <span class="curPon" @click="updatePasClick" style="display:block;margin-left: 10px;font-size: 14px;">修改密码</span>
        <span class="curPon" @click="logout" style="display:block;margin-left: 10px;font-size: 14px;">退出登录</span>
      </div>
    </div>
    <!-- <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    
  <upPas v-if="dialogData.dialogVisible" :params="dialogData" @listenDialog="listenDialog"></upPas>
  <dialogCon v-if="dialogData1.dialogVisible" :params="dialogData1" @listenDialog="listenDialog"></dialogCon>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import upPas from '@/views/login/upPas.vue'
import baseApi from '@/api/baseApi.js';
  import dialogCon from '@/components/dialog'
import qrCode from './qrCode.vue' 

export default {
  components: {
    Breadcrumb,
    Hamburger,
    upPas,dialogCon
  },
  data(){
    return{
      username:'',
      nickName:'',
      adminId:'',
        // 修改密码   动态组件
        updatePasData:{
          dialogVisible:false,
          title:'修改密码',
          width:'500px',
          type:1,
          isComponebt:true,//显示组件
          component:upPas,//组件传递
          data:{id:''},
        },
        dialogData:{},//弹窗数据
        dialogData1:{},//二维码
        
        // 二维码
        financingData:{
          dialogVisible:false,
          title:'业务二维码',
          width:'20%',
          isComponebt:true,//显示组件
          component:null,//组件传递
          data:{id:''},
        },
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  created () {
    this.username = sessionStorage.getItem("username")
    this.nickName = sessionStorage.getItem("nickName")
    this.adminId = sessionStorage.getItem("adminId")
    if (sessionStorage.getItem("changePass") === "0") {
      this.updatePasClick()
    }
  },
  methods: {
      tableRowClassName({row, rowIndex}) {
        if (rowIndex % 2 == 0) {
          return 'warning-row';
        } else {
          return 'success-row';
        }
      },
    
      //监听dialog事件
      listenDialog(data){
        console.log("监听数据",data)
        let that = this;
        let type = data.type || '0';
        switch(type){
          case 1:
            //修改密码
            let username = sessionStorage.getItem("username") || "";
            let bodyData = {
              username:username,
              oldPassword:data.data.oldPassword,
              newPassword:data.data.newPassword,
              newPasswordSure:data.data.newPasswordSure
            }
            if(bodyData.newPassword != bodyData.newPasswordSure){
              return this.$utils.msg('新密码与确认密码不一致，请重新输入','error')
            }
            baseApi.updatePassword(bodyData)
            .then( res => {
              this.$message({
                  message: '修改成功',
                  type: 'success',
                  duration:1500
                })
                that.dialogData.dialogVisible = false;
            });
          break;
          default:
            console.log("监听事件",data)
        }
      },

      authCode(){
        let that = this;
        that.dialogData1 = that.financingData;
        that.dialogData1.title=`业务二维码`
        that.dialogData1.width = '25%'
        that.dialogData1.component = qrCode;
        let userId = sessionStorage.getItem("adminId") || '0';
        that.dialogData1.data.id =userId;
        that.dialogData1.data.paramsData={
          //url:`https://user.duolun.net.cn/pages/public/crmWXAuth?userId=${userId}`,
          url:`https://www.duolun.net.cn?userId=${userId}`,
          id:userId
        }
        that.dialogData1.dialogVisible = true;
        console.log("二维码组件",qrCode,userId);
      },
      //修改密码
      updatePasClick(){
        console.log("修改数据")
        let that = this;
        that.dialogData = that.updatePasData;
        that.dialogData.dialogVisible = true;
      },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$confirm('是否退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sessionStorage.removeItem('alarmShown')
          sessionStorage.removeItem('alarmInfo')
          this.$store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        });
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.curPon{
  cursor: pointer;
}
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
    display: flex;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue